import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Config, LANDING_CONFIGURATION, SLUG_CONVERTER } from 'src/core/config/landing-config';
import {
  MAP_OPTIONS_START,
  MAP_OPTIONS_START_DEFAULT,
  buildingLabelsStack,
  civic_markers,
  clusters,
  ico_noa,
  ico_p,
  ico_pfs,
  ico_picked,
  ico_pink,
  ico_poi,
  ico_temp,
  icons_pops
} from 'src/core/config/map-config';
import { environment } from 'src/environments/environment';
import { LandingPageService } from '../landing-page.service';
import { MarkerIcon } from '../models/map';
import { Point } from '../models/point';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements AfterViewInit, OnChanges {
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;

  @Input() selectedCoordinates: any;
  @Input() poiList: any;
  @Input() pfsList: any;
  @Input() roeList: any;
  @Input() cnoList: any;
  @Input() pozzettoList: any;
  @Input() noaList: any;
  @Input() schoolList: any;
  @Input() healthcareList: any;
  @Input() kmlList: any;
  @Input() btsClusters: any;
  @Input() buildingClusters: any;
  @Input() schoolClusters: any;
  @Input() healthcareClusters: any;
  @Input() puntiIntermediClusters: any;

  @Input() canAddPoints: any;

  @Input() schoolForMap: any[];
  @Input() healthcareForMap: any[];

  @Output() mapLoaded = new EventEmitter<any>();
  @Output() leftClick = new EventEmitter<any>();
  @Output() clickBuilding = new EventEmitter<any>();
  @Output() clickPop = new EventEmitter<any>();
  @Output() clickPfs = new EventEmitter<any>();
  @Output() clickRoe = new EventEmitter<any>();
  @Output() clickCno = new EventEmitter<any>();
  @Output() clickPozzetti = new EventEmitter<any>();
  @Output() clickPoi = new EventEmitter<any>();
  @Output() clickSchool = new EventEmitter<any>();
  @Output() clickHealthcare = new EventEmitter<any>();
  @Output() clickBts = new EventEmitter<any>();
  @Output() clickPuntiIntermedi = new EventEmitter<any>();
  @Output() mapZoom = new EventEmitter<any>();
  @Output() mapBounds = new EventEmitter<any>();
  @Output() dragEnd = new EventEmitter<any>();

  private isMapLoaded = false
  private intervalClick: any;
  private intervalZoom: any;
  private intervalBBox: any;
  private lastZoom: any;
  private lastBBox: any;
  public clusterMarkers: google.maps.Marker[] = [];
  private abPopsMarkers: google.maps.Marker[] = [];
  private CDPopsMarkers: google.maps.Marker[] = [];
  private AGFPopsMarkers: google.maps.Marker[] = [];
  private olaPopsMarkers: google.maps.Marker[] = [];
  private pfsMarkers: google.maps.Marker[] = [];
  private roeMarkers: google.maps.Marker[] = [];
  private cnoMarkers: google.maps.Marker[] = [];
  private pozzettiMarkers: google.maps.Marker[] = [];
  private poiMarkers: google.maps.Marker[] = [];
  public noaMarkers: google.maps.Marker[] = [];
  private schoolMarkers: google.maps.Marker[] = [];
  private healthcareMarkers: google.maps.Marker[] = [];
  private kml_features = new Map<string, google.maps.KmlLayer>();
  private kmlLayers = [];
  private storedBuildings: any[] = [];
  private storedClusters: any[] = [];
  public selectedPoints: Point[] = [null, null, null];
  private markersList = [];
  private env = environment;
  config: Config = this.env.controls.unique_environment ? LANDING_CONFIGURATION[SLUG_CONVERTER[window.location.pathname.split('/')[1]]] : LANDING_CONFIGURATION[this.env.serviceSlug];

  @Input() abPops: any[] = [];
  @Input() cdPops: any[] = [];
  @Input() agfPops: any[] = [];
  @Input() olaPops: any[] = [];

  // This boolean is needed for prevent loop of the generation of provincial pops
  // that make map navigation slow
  private shownAbPops = false;

  private RequiresNumberedMakers = ["bea", "darkfiber"];

  map: google.maps.Map;

  constructor(private landingPageService: LandingPageService, public zone: NgZone) { }

  ngAfterViewInit() {
    this.mapInitializer();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.btsClusters) {
      if (this.map && this.map.getZoom() >= 12) {
        this.manageBts();
      }
    }
    if (changes.puntiIntermediClusters) {
      if (this.map && this.map.getZoom() >= 12) {
        this.managePuntiIntermedi();
      }
    }
    if (changes.buildingClusters || changes.schoolClusters || changes.healthcareClusters) {
      if (this.map && this.map.getZoom() >= 12) {
        this.manageBuildingsAndClusters();
      }
    }
    if (changes.noaList) {
      this.clearMarkers([this.noaMarkers]);
      this.noaMarkers = [];
      if (this.noaList && this.noaList.length) {
        this.markNoaList(this.noaMarkers)
      }
    }
    if (changes.mapButtons) {
      this.setMapButton('kml')
    }
    if (changes.abPops || changes.cdPops || changes.agfPops || changes.olaPops) {
      this.setMapButton('pops')
    }
    if (changes.requestType) {
      if (changes.requestType.currentValue !== 'id_bts_noa' && changes.requestType.currentValue !== 'id_school') {
        this.map?.setCenter(MAP_OPTIONS_START_DEFAULT.center);
        this.map?.setZoom(MAP_OPTIONS_START_DEFAULT.zoom);
        this.clearMarkers([this.noaMarkers]);
        this.clearMarkers([this.schoolMarkers]);
      } else {
        this.map?.setCenter(MAP_OPTIONS_START_DEFAULT.center);
        this.map?.setZoom(MAP_OPTIONS_START_DEFAULT.zoom);
      }
      if (changes.requestType.currentValue !== 'id_school') {
        this.map?.setCenter(MAP_OPTIONS_START_DEFAULT.center);
        this.map?.setZoom(MAP_OPTIONS_START_DEFAULT.zoom);
        this.clearMarkers([this.schoolMarkers]);
      }
      if (changes.requestType.currentValue !== 'id_healthcare') {
        this.map?.setCenter(MAP_OPTIONS_START_DEFAULT.center);
        this.map?.setZoom(MAP_OPTIONS_START_DEFAULT.zoom);
        this.clearMarkers([this.healthcareMarkers]);
      }
      if (changes.requestType.currentValue === 'id_school') {
      } else {
        this.map?.setCenter(MAP_OPTIONS_START_DEFAULT.center);
        this.map?.setZoom(MAP_OPTIONS_START_DEFAULT.zoom);
      }
      if (changes.requestType.currentValue === 'id_healthcare') {
      } else {
        this.map?.setCenter(MAP_OPTIONS_START_DEFAULT.center);
        this.map?.setZoom(MAP_OPTIONS_START_DEFAULT.zoom);
      }
    }
  }

  private tooltipList: google.maps.InfoWindow[] = []
  private tooltipTimer: any | null = null
  private tooltipTime = 2000

  private closeAllTooltips() {
    for (const tp of this.tooltipList) {
      tp.close()
    }
  }

  private addTooltip(infowindow: google.maps.InfoWindow) {
    this.tooltipList.push(infowindow)
  }

  private tooltipsDebounce(infowindow: google.maps.InfoWindow, cb: () => void) {
    this.addTooltip(infowindow)
    clearTimeout(this.tooltipTimer)
    this.tooltipTimer = setTimeout(() => {
      this.closeAllTooltips()
      if (cb && typeof cb === 'function') {
        cb()
      }
    }, this.tooltipTime)
  }



  private mapInitializer() {
    this.map = new google.maps.Map(
      this.gmap.nativeElement,
      MAP_OPTIONS_START[this.config.data.service_slug],
    );
    this.addListenersToMap();
  }

  private addListenersToMap() {

    const { map, leftClick, mapZoom, mapBounds, dragEnd } = this;

    google.maps.event.addListener(map, 'idle', (event) => {

      if (!this.isMapLoaded) {
        this.mapLoaded.emit()
      }
      this.isMapLoaded = true

      // se lo zoom è invariato si tratta allora di inertia su bbox
      const zoom = map.getZoom();
      if (this.lastZoom === zoom) {
        this.emitBounds(true)
      }

    })

    google.maps.event.addListener(map, 'dragstart', (event) => {
      this.closeAllTooltips()
    })

    const listeners = this.landingPageService.config.map.map_events;
    listeners.map((listener) => {
      google.maps.event.addListener(map, listener, (event) => {
        switch (listener) {
          case 'click':
            this.intervalClick = setTimeout(() => {
              if (map.getZoom() >= 12) {
                leftClick.emit(event);
              }
            }, 500);
            break;
          case 'dblclick':
            clearTimeout(this.intervalClick);
            map.setZoom(map.getZoom() + 1);
            break;
          case 'zoom_changed':
            this.emitZoom()
            this.closeAllTooltips()
            break;
          // case 'bounds_changed':
          // 	clearTimeout(this.intervalBBox);

          // 	this.intervalBBox = setTimeout(() => {
          // 		const bounds = map.getBounds();
          // 		const bboxString = JSON.stringify(bounds)
          // 		if (this.lastBBox !== bboxString) {
          // 			mapBounds.emit(bounds)
          // 		}
          // 		this.lastBBox = bboxString
          // 	}, 500);

          // 	break;
          // case 'dragend':
          // 	dragEnd.emit(null);
          // 	break;
        }
      });
    });
  }

  private emitZoom() {
    clearTimeout(this.intervalZoom);
    this.intervalZoom = setTimeout(() => {
      const zoom = this.map.getZoom();
      if (this.lastZoom !== zoom) {
        this.mapZoom.emit(zoom);
      }
      this.lastZoom = zoom
    }, 700);
  }

  private emitBounds(force = false) {
    clearTimeout(this.intervalBBox);
    this.intervalBBox = setTimeout(() => {
      const bounds = this.map.getBounds();
      const bboxString = JSON.stringify(bounds)
      if (this.lastBBox !== bboxString || force) {
        // this.mapBounds.emit(bounds)
        this.dragEnd.emit(null);
      }
      this.lastBBox = bboxString
    }, 700);
  }

  public setMapButton(type) {
    if (!this.landingPageService.mapButtons[type]) {
      return;
    }
    const active = this.landingPageService.mapButtons[type].active;

    switch (type) {
      case 'pops':
        this.clearMarkers([
          this.abPopsMarkers,
          this.CDPopsMarkers,
          this.AGFPopsMarkers,
          this.olaPopsMarkers,
        ]);
        if (active) {
          this.shownAbPops = false;
          this.markAllPops();
        }
        break;
      case 'pfs':
        if (active) {
          this.markPfs(this.pfsMarkers);
        } else {
          this.clearMarkers([this.pfsMarkers]);
        }
        break;
      case 'roe':
        if (active) {
          this.markRoe(this.roeMarkers);
        } else {
          this.clearMarkers([this.roeMarkers]);
        }
        break;
      case 'cno':
        if (active) {
          this.markCno(this.cnoMarkers);
        } else {
          this.clearMarkers([this.cnoMarkers]);
        }
        break;
      case 'pozzetto':
        if (active) {
          this.markPozzetti(this.pozzettiMarkers);
        } else {
          this.clearMarkers([this.pozzettiMarkers]);
        }
        break;
      case 'poi':
        if (active) {
          this.markPoiList(this.poiMarkers);
        } else {
          this.clearMarkers([this.poiMarkers]);
        }
        break;
      case 'kml':
        if (active) {
          this.markKmlList();
        } else {
          this.clearKml();
        }
        break;
    }
  }

  public drawIndustrialLayers(url) {
    const l = new google.maps.KmlLayer({
      url: url,
      clickable: false,
      suppressInfoWindows: true,
      preserveViewport: true,
      map: this.map,
      zIndex: 50
    });
    l.setMap(this.map)
  }

  private markAllPops() {
    this.markPops(this.abPops, 'provincial', this.abPopsMarkers);
    this.markPops(this.cdPops, 'cd', this.CDPopsMarkers);
    this.markPops(this.agfPops, 'agf', this.AGFPopsMarkers);
    this.markPops(this.olaPops, 'ola', this.olaPopsMarkers);
  }



  private markPops(popsList, type, markersList) {
    // this.tooltipList = []

    popsList.map((pop) => {
      const latLng = { lat: pop.lat, lng: pop.lng };

      const popMarker = new google.maps.Marker({
        position: latLng,
        icon: icons_pops[type],
        clickable: true,
      });
      const infowindow = new google.maps.InfoWindow();

      popMarker.addListener('mouseover', () => {
        infowindow.setContent(pop.nome);
        infowindow.open(this.map, popMarker);

        this.tooltipsDebounce(infowindow, () => {
          infowindow.close();
        })
      });
      popMarker.addListener('mouseout', () => {
        infowindow.close();
      });

      if (this.landingPageService.config.pop.click || this.landingPageService.config.pcn.click || this.landingPageService.config.pop_ola.click || (this.env.controls.agf && this.landingPageService.config.pop_agf.click)) {
        popMarker.addListener('click', () => {
          this.clickPop.emit(pop);
        });
      }
      markersList.push(popMarker);
    });
    markersList.forEach((marker) => {
      marker.setMap(this.map);
    });
  }

  private markPfs(markersList) {
    this.pfsList.map((pfs: any) => {
      const latLng = { lat: pfs.coordinates.lat, lng: pfs.coordinates.lng };
      const pfsMarker = new google.maps.Marker({
        position: latLng,
        icon: ico_pfs,
        clickable: true,
      });
      const infowindow = new google.maps.InfoWindow();
      pfsMarker.addListener('mouseover', () => {
        infowindow.setContent(pfs.code);
        infowindow.open(this.map, pfsMarker);

        this.tooltipsDebounce(infowindow, () => {
          infowindow.close();
        })
      });
      pfsMarker.addListener('mouseout', () => {
        infowindow.close();
      });
      if (this.landingPageService.config.pfs.click) {
        pfsMarker.addListener('click', () => {
          this.clickPfs.emit(pfs);
        })
      }

      markersList.push(pfsMarker);
    });
    markersList.forEach((marker) => {
      marker.setMap(this.map);
    });
  }

  private markRoe(markersList) {
    this.roeList.map((roe: any) => {
      const latLng = { lat: roe.coordinates.lat, lng: roe.coordinates.lng };
      const roeMarker = new google.maps.Marker({
        position: latLng,
        icon: ico_pfs,
        clickable: true,
      });
      const infowindow = new google.maps.InfoWindow();
      roeMarker.addListener('mouseover', () => {
        infowindow.setContent(roe.code);
        infowindow.open(this.map, roeMarker);

        this.tooltipsDebounce(infowindow, () => {
          infowindow.close();
        })
      });
      roeMarker.addListener('mouseout', () => {
        infowindow.close();
      });

      if (this.landingPageService.config.roe.click) {
        roeMarker.addListener('click', () => {
          this.clickRoe.emit(roe);
        })
      }
      markersList.push(roeMarker);
    });
    markersList.forEach((marker) => {
      marker.setMap(this.map);
    });
  }

  private markCno(markersList) {
    this.cnoList.map((cno: any) => {
      const latLng = { lat: cno.coordinates.lat, lng: cno.coordinates.lng };
      const cnoMarker = new google.maps.Marker({
        position: latLng,
        icon: ico_pfs, // TODO
        clickable: true,
      });
      const infowindow = new google.maps.InfoWindow();
      cnoMarker.addListener('mouseover', () => {
        infowindow.setContent(cno.code);
        infowindow.open(this.map, cnoMarker);

        this.tooltipsDebounce(infowindow, () => {
          infowindow.close();
        })
      });
      cnoMarker.addListener('mouseout', () => {
        infowindow.close();
      });
      if (this.landingPageService.config.cno.click) {
        cnoMarker.addListener('click', () => {
          this.clickCno.emit(cno);
        })
      }

      markersList.push(cnoMarker);
    });
    markersList.forEach((marker) => {
      marker.setMap(this.map);
    });
  }

  private markPozzetti(markersList) {
    this.pozzettoList.map((pozzetto: any) => {
      const latLng = { lat: pozzetto.coordinates.lat, lng: pozzetto.coordinates.lng };
      const pozzettiMarker = new google.maps.Marker({
        position: latLng,
        icon: ico_pfs, // TODO
        clickable: true,
      });
      const infowindow = new google.maps.InfoWindow();
      pozzettiMarker.addListener('mouseover', () => {
        infowindow.setContent(pozzetto.code);
        infowindow.open(this.map, pozzettiMarker);

        this.tooltipsDebounce(infowindow, () => {
          infowindow.close();
        })
      });
      pozzettiMarker.addListener('mouseout', () => {
        infowindow.close();
      });
      if (this.landingPageService.config.pozzetto.click) {
        pozzettiMarker.addListener('click', () => {
          this.clickPozzetti.emit(pozzetto);
        })
      }

      markersList.push(pozzettiMarker);
    });
    markersList.forEach((marker) => {
      marker.setMap(this.map);
    });
  }

  private markPoiList(markersList) {
    this.poiList.map((poi: any) => {
      const latLng = { lat: poi.coordinates.lat, lng: poi.coordinates.lng };
      const poiMarker = new google.maps.Marker({
        position: latLng,
        icon: ico_poi,
        clickable: true,
      });
      const infowindow = new google.maps.InfoWindow();
      poiMarker.addListener('mouseover', () => {
        if (this.config.poi.is_registered) {
          infowindow.setContent(poi.fullname && this.landingPageService.config.poi.is_registered ? poi.fullname : poi.address);
        } else {
          infowindow.setContent(poi.fullname ? poi.fullname : poi.address);
        }
        infowindow.open(this.map, poiMarker);

        this.tooltipsDebounce(infowindow, () => {
          infowindow.close();
        })
      });
      poiMarker.addListener('mouseout', () => {
        infowindow.close();
      });
      if (this.landingPageService.config.poi.click) {
        poiMarker.addListener('click', () => {
          this.clickPoi.emit(poi);
        })
      }

      markersList.push(poiMarker);
    });
    markersList.forEach((marker) => {
      marker.setMap(this.map);
    });
  }

  private markNoaList(markersList) {
    if (this.noaList && this.noaList.length) {
      this.noaList.map((noa: any) => {
        const latLng = { lat: noa.coordinates.lat, lng: noa.coordinates.lng };
        const noaMarker = new google.maps.Marker({
          position: latLng,
          icon: ico_noa,
          clickable: true,
        });
        const infowindow = new google.maps.InfoWindow();
        noaMarker.addListener('mouseover', () => {
          infowindow.setContent('#' + noa.id);
          infowindow.open(this.map, noaMarker);

          this.tooltipsDebounce(infowindow, () => {
            infowindow.close();
          })
        });
        noaMarker.addListener('mouseout', () => {
          infowindow.close();
        });
        if (this.landingPageService.config.noa.click) {
          noaMarker.addListener('click', () => {
            this.clickBts.emit({ element: noa, pointType: 'NOA' });
          })
        }


        markersList.push(noaMarker);
        markersList.forEach((marker) => {
          marker.setMap(this.map);
        });
      });
    }
  }

  private markKmlList() {
    this.kmlList.files.map((kml) => {
      const current = new google.maps.KmlLayer({
        clickable: false,
        preserveViewport: true,
        map: this.map,
        suppressInfoWindows: false,
        url: kml,
      });
      this.kmlLayers.push(current);
      for (const layer of this.kmlLayers) {
        this.kml_features.set('KML', layer);
      }
    });
  }

  public markPoint(point, index?) {
    const isWavelength = this.landingPageService.config.data.service_slug === "wavelength"

    this.removeMarkersTemp()
    this.removeMarkersByIndex(point.end);
    let markerIcon: MarkerIcon;

    if (this.canAddPoints && this.config.data.service_slug !== "bea") {
      if (this.markersList.length && this.markersList[0].icon.url === ico_picked.url) { // resets the first icon
        this.markPoint(this.selectedPoints[0]);
      }
      markerIcon = this.landingPageService.config.map.marker_default_icon.url === ico_pink.url ? ico_pink : ico_picked;
    } else {
      //controllo se la landing necessita di marker numerati
      if (index != undefined && this.RequiresNumberedMakers.includes(this.config.data.service_slug)) {
        markerIcon = ico_p[index];
      }
      else {
        markerIcon = ico_picked;
      }
    }

    if (point.isTemp) {
      markerIcon = ico_temp;
    }

    const marker = new google.maps.Marker({
      position: point.coordinates,
      icon: markerIcon,
      clickable: false
    });

    if (isWavelength) {
      marker.set('icon', point.isTemp ? ico_temp : ico_pink);
      marker.set('label', { text: String(point.end + 1), color: 'white' });
    }

    if (!point.isTemp && this.landingPageService.config.map.marker_has_label && this.canAddPoints) {
      marker.set('label', { text: String(point.end + 1), color: 'white' });
    }
    marker.setZIndex(point.type === 'Poi' || point.type === 'POP' ? 999 : 1)
    marker['isTemp'] = point.isTemp;
    marker['type'] = point.type;
    marker['end'] = point.end;
    this.markersList.push(marker);
    marker.setMap(this.map);
  }

  private manageBts() {
    let buildingsToMark;
    if (this.btsClusters.NOA || this.btsClusters.BUILDING) {
      buildingsToMark = this.btsClusters.NOA.concat(this.btsClusters.BUILDING);
    } else {
      buildingsToMark = this.btsClusters;
    }
    if (buildingsToMark && buildingsToMark.results) {
      if (this.clusterMarkers) {
        this.resetAllMarkers(this.clusterMarkers, 'clusters');
      }
      let type = '';
      if (buildingsToMark.cluster) {
        type = 'cluster';
        for (const cluster of buildingsToMark.results) {
          this.storedClusters.push(cluster);
        }
        this.storedClusters.map((element) => {
          this.markBts(element, new google.maps.LatLng(element.coordinates.lat, element.coordinates.lng), type);
        });
      } else {
        type = 'buildings';
        let buildings = [];
        if (buildingsToMark.results.NOA) {
          buildings = buildings.concat(buildingsToMark.results.NOA)
        };
        if (buildingsToMark.results.BUILDING) {
          buildings = buildings.concat(buildingsToMark.results.BUILDING)
        };
        for (const building of buildings) {
          if (this.notAlreadyExists(building, this.storedBuildings)) {
            this.storedBuildings.push(building);
          }
        }
        this.storedBuildings.map((element) => {
          this.markBts(element, new google.maps.LatLng(element.coordinates.lat, element.coordinates.lng), type);
        });
      }
    }
  }

  private managePuntiIntermedi() {
    let buildingsToMark: any = [];
    if (this.puntiIntermediClusters.POZZETTO || this.puntiIntermediClusters.ROE || this.puntiIntermediClusters.CNO) {
      buildingsToMark = this.puntiIntermediClusters.POZZETTO.concat(this.puntiIntermediClusters.ROE).concat(this.puntiIntermediClusters.CNO);
    } else {
      buildingsToMark = this.puntiIntermediClusters;
    }
    if (buildingsToMark && buildingsToMark.results) {
      if (this.clusterMarkers) {
        this.resetAllMarkers(this.clusterMarkers, 'clusters');
      }
      let type = '';
      if (buildingsToMark.cluster) {
        type = 'cluster';
        for (const cluster of buildingsToMark.results) {
          this.storedClusters.push(cluster);
        }
        this.storedClusters.map((element) => {
          this.markPuntiIntermedi(element, new google.maps.LatLng(element.coordinates.lat, element.coordinates.lng), type);
        });
      } else {
        type = 'buildings';
        let buildings = [];
        if (buildingsToMark.results.POZZETTO) {
          buildings = buildings.concat(buildingsToMark.results.POZZETTO)
        };
        if (buildingsToMark.results.ROE) {
          buildings = buildings.concat(buildingsToMark.results.ROE)
        };
        if (buildingsToMark.results.CNO) {
          buildings = buildings.concat(buildingsToMark.results.CNO)
        };
        for (const building of buildings) {
          if (this.notAlreadyExists(building, this.storedBuildings)) {
            this.storedBuildings.push(building);
          }
        }
        this.storedBuildings.map((element) => {
          this.markPuntiIntermedi(element, new google.maps.LatLng(element.coordinates.lat, element.coordinates.lng), type);
        });
      }
    }
  }

  private markBts(element, latLng, type) {
    let pointType = element.point_type === 'NOA' ? 'NOA' : 'BUILDING'; // necessary to check with the config if it is clickable
    if (!this.env.controls.agf && pointType === 'BUILDING' && type !== 'cluster') {
      return;
    }
    const clusterMarker = new google.maps.Marker({
      position: latLng,
      clickable: false,
      zIndex: type === 'cluster' ? 999999 : -1
    });
    if (type === 'cluster') {
      clusterMarker.set('icon', clusters[element.type]);
      clusterMarker.set('label', { text: element.tot_buildings.toString(), color: 'white' });
    } else {
      clusterMarker.set('icon', civic_markers[element.coverage.toLowerCase()]);
      if (this.config.bts.types[pointType] && this.landingPageService.config.bts.types[pointType].click) {
        clusterMarker.set('clickable', true);
        const infowindow = new google.maps.InfoWindow();
        clusterMarker.addListener('mouseover', () => {
          let label = null;
          infowindow.setContent(label ? '#' + label : buildingLabelsStack(element));
          infowindow.open(this.map, clusterMarker);

          this.tooltipsDebounce(infowindow, () => {
            infowindow.close();
          })
        });
        clusterMarker.addListener('mouseout', () => {
          infowindow.close();
        });
        if (this.config.bts.types[pointType] && this.landingPageService.config.bts.types[pointType].click) {
          clusterMarker.addListener('click', () => {
            this.clickBts.emit({ element, pointType });
            infowindow.close();
          });
        }

      }
    }

    clusterMarker.setMap(this.map);
    this.clusterMarkers.push(clusterMarker);
  }

  private markPuntiIntermedi(element, latLng, type) {
    let pointType: string = '';
    if (element.point_type === 'POZZETTO') {
      pointType = 'POZZETTO';
    } else if (element.point_type === 'ROE') {
      pointType = 'ROE';
    } else {
      pointType = 'CNO';
    }
    const clusterMarker = new google.maps.Marker({
      position: latLng,
      clickable: false,
      zIndex: type === 'cluster' ? 999999 : -1
    });
    if (type === 'cluster') {
      clusterMarker.set('icon', clusters[element.type]);
      clusterMarker.set('label', { text: element.tot_buildings.toString(), color: 'white' });
    } else {
      clusterMarker.set('icon', civic_markers[element.coverage_type.toLowerCase()]);
      if (this.config.punti_intermedi.types[pointType] && this.landingPageService.config.punti_intermedi.types[pointType].load) {
        clusterMarker.set('clickable', true);
        const infowindow = new google.maps.InfoWindow();
        clusterMarker.addListener('mouseover', () => {
          let label = null;
          infowindow.setContent(label ? '#' + label : buildingLabelsStack(element));
          infowindow.open(this.map, clusterMarker);

          this.tooltipsDebounce(infowindow, () => {
            infowindow.close();
          })
        });
        clusterMarker.addListener('mouseout', () => {
          infowindow.close();
        });


        if (this.config.punti_intermedi.types[pointType] && this.landingPageService.config.punti_intermedi.types[pointType].click) {
          clusterMarker.addListener('click', () => {
            switch (element.type) {
              case 'CNO':
                this.clickCno.emit(element)
                break;
              case 'POZZETTO':
                this.clickPozzetti.emit(element)
                break;
              case 'ROE':
                this.clickRoe.emit(element)
                break;
              default:
                break;
            }
            this.map.setCenter({
              lat: element.coordinates.lat,
              lng: element.coordinates.lng,
            });
            this.mapBounds.emit(this.map.getBounds());
          });
        }
      }
    }

    clusterMarker.setMap(this.map);
    this.clusterMarkers.push(clusterMarker);
  }

  private manageBuildingsAndClusters() {
    let buildingsToMark: any = [];
    if (this.landingPageService.config.building.load) {
      buildingsToMark = this.buildingClusters;
    } else if (this.landingPageService.config.school.load) {
      buildingsToMark = this.schoolClusters;
    } else if (this.landingPageService.config.healthcare.load) {
      buildingsToMark = this.healthcareClusters;
    }
    if (buildingsToMark && buildingsToMark.results) {
      if (this.clusterMarkers) {
        this.resetAllMarkers(this.clusterMarkers, 'clusters');
      }
      let type = '';
      if (buildingsToMark.cluster) {
        type = 'cluster';
        for (const cluster of buildingsToMark.results) {
          this.storedClusters.push(cluster);
        }
        this.storedClusters.map((element) => {
          const { coordinates } = element.coordinates;
          this.markCluster(element, new google.maps.LatLng(coordinates[1], coordinates[0]), type);
        });
      } else {
        type = 'buildings';
        for (const building of buildingsToMark.results) {
          if (this.notAlreadyExists(building, this.storedBuildings)) {
            this.storedBuildings.push(building);
          }
        }
        this.storedBuildings.map((element) => {
          const { coordinates } = element.coordinates;
          this.markCluster(element, new google.maps.LatLng(coordinates[1], coordinates[0]), type);
        });
      }
    }
  }

  notAlreadyExists(obj, list) {
    let i: number;
    for (i = 0; i < list.length; i++) {
      if (list[i].id === obj.id) {
        return false;
      }
    }
    return true;
  }

  private markCluster(element, latLng, type) {
    const clusterMarker = new google.maps.Marker({
      position: latLng,
      clickable: false,
      zIndex: type === 'cluster' ? 999999 : -1
    });
    if (type === 'cluster') {
      clusterMarker.set('icon', clusters[element.type]);
      clusterMarker.set('label', { text: element.tot_buildings.toString(), color: 'white' });
    } else {
      clusterMarker.set('icon', civic_markers[element.type.toLowerCase()]);
      if (this.landingPageService.config.building.load || this.landingPageService.config.noa.load || this.landingPageService.config.school.load || this.landingPageService.config.healthcare.load) {
        clusterMarker.set('clickable', true);
        const infowindow = new google.maps.InfoWindow();
        clusterMarker.addListener('mouseover', () => {
          let label = null;
          if (this.landingPageService.config.school.load) {
            label = buildingLabelsStack(element);
          }
          if (this.landingPageService.config.healthcare.load) {
            label = buildingLabelsStack(element);
          }
          infowindow.setContent(label ? label : buildingLabelsStack(element));
          infowindow.open(this.map, clusterMarker);

          this.tooltipsDebounce(infowindow, () => {
            infowindow.close();
          })
        });
        clusterMarker.addListener('mouseout', () => {
          infowindow.close();
        });


        if (this.landingPageService.config.school.click) {
          clusterMarker.addListener('click', () => {
            this.clickSchool.emit(element);
            infowindow.close();
          });
        } else if (this.landingPageService.config.healthcare.click) {
          clusterMarker.addListener('click', () => {
            this.clickHealthcare.emit(element);
            infowindow.close();
          });
        } else {
          clusterMarker.addListener('click', () => {
            this.clickBuilding.emit(element);
            this.map.setCenter({
              lat: element.coordinates.coordinates[1],
              lng: element.coordinates.coordinates[0],
            });
            this.mapBounds.emit(this.map.getBounds());
          });
        }
      }
    }

    clusterMarker.setMap(this.map);
    this.clusterMarkers.push(clusterMarker);
  }

  public resetAllMarkers(markers, type?) {
    if (markers && markers.length) {
      for (const marker of markers) {
        marker.setMap(null);
      }
      switch (type) {
        case 'clusters':
          this.clusterMarkers = [];
          this.storedClusters = [];
          break;
      }
    }
  }

  public removeMarkersByType(type: String) {
    const list = this.markersList.filter(e => e.type === type);
    for (const m of list) {
      m.setMap(null);
    }
    this.markersList = this.markersList.filter(e => e.type !== type);
  }

  public removeMarkersTemp() {
    const list = this.markersList.filter(e => e.isTemp);
    for (const m of list) {
      m.setMap(null);
    }
    this.markersList = this.markersList.filter(e => !e.isTemp);
  }

  public removeMarkersByIndex(end: number) {
    const list = this.markersList.filter(e => e.end === end);
    for (const m of list) {
      m.setMap(null);
    }
    this.markersList = this.markersList.filter(e => e.end !== end);
  }

  public clearMarkers(markersList: any[], keys?: string[]) {
    if (!markersList) return;

    // Supporta sia array di array che array semplice
    markersList.forEach((list, index) => {
      const items = Array.isArray(list) ? list : [list];
      items.forEach((marker) => {
        if (marker && typeof marker.setMap === 'function') {
          marker.setMap(null);
        }
      });
      // Svuota l'array originale
      if (Array.isArray(list)) {
        list.length = 0;
      } else {
        markersList[index] = null as any; // se array semplice
      }
    });

    // Svuota eventuali proprietà specifiche
    if (keys && keys.length) {
      keys.forEach((key) => {
        if (this[key] && Array.isArray(this[key])) {
          this[key].forEach((m) => m.setMap(null));
          this[key].length = 0;
        }
      });
    }
  }

  private clearKml() {
    if (this.kmlLayers.length) {
      for (const layer of this.kmlLayers) {
        this.kml_features.set(layer, null);
        layer.setMap(layer.getMap() ? null : this.map);
      }
      this.kmlLayers = [];
      this.kml_features.clear();
    }
  }

  public zoomToCoordinates(latlng, zoom = null) {
    zoom = zoom ? zoom : 19;
    this.map.setZoom(zoom);
    this.map.setCenter(latlng);
  }

  fitMapsPositions(points: any[]) {
    const bounds = new google.maps.LatLngBounds();
    for (const p of points) {
      if (p && p.coordinates) {
        bounds.extend(this.latLngFromCoordinata([p.coordinates.lat, p.coordinates.lng]));
      }
    }
    this.map.fitBounds(bounds);
    if (this.selectedPoints && this.selectedPoints.length && this.selectedPoints[0] && this.selectedPoints[0].coordinates && (!this.selectedPoints[1] || (this.selectedPoints[1] && !this.selectedPoints[1].coordinates))) {
      this.map.setZoom(18)
    }
  }

  latLngFromCoordinata(coordinata: any): google.maps.LatLng {
    if (!coordinata) {
      return null;
    }
    return new google.maps.LatLng(coordinata[0], coordinata[1]);
  }

  showMarker(point, index?) {
    this.selectedPoints[point.end] = point;
    this.markPoint(point, index);
    if (this.selectedPoints && this.selectedPoints.length) {
      this.fitMapsPositions(this.selectedPoints);
    }
  }

  showTempMarker(point) {
    this.markPoint(point);
  }

}
